<app-main-container>
  <div class="px-5 flex flex-column w-full max-w-30rem">
    <!--Titre-->
    <header class="py-6 flex w-full justify-content-center">
      <h2 class="text-center">Ajouter un produit</h2>
    </header>
    <!--Contenu form-->
    <main class="flex flex-column w-full">
      <form [formGroup]="createProductFg"  (submit)="createProduct()">
        <app-creat-product [fg]="createProductFg"></app-creat-product>
      </form>
      <div class="flex w-full justify-content-center align-items-center">
        <p-button (onClick)="createProduct()"  type="submit" severity="success" class="p-button-success full--width--button" label="Ajouter le produit"/>
      </div>
    </main>
  </div>
</app-main-container>
